import { IFiltered } from 'interfaces/api-response';
import { IBaseUserAvatar } from 'interfaces/base-user';
import { IEntAccountAvatar } from 'pages/dashboard/components/ent-account/interface';
import { IContentAvatar } from '../../../content/interface';
import {
  CertificateSessionCompletionFilter,
  CertificateStatus,
  Frequency,
  IAvailableTime,
  IBadge,
  ICertificate,
  IIssuedCertificate,
  IInvitation,
  ISessionMeta,
  IWaitingMedia,
  IEventLocation,
} from '../../interface';
import { IExpertAvatar } from '../../../../../../interface';

export enum ModalState {
  deletePending = 'DELETE_PENDING',
  deleteComplete = 'DELETE_COMPLETE',
  close = 'CLOSE',
  resendInvite = 'RESEND_INVITE',
  active = 'ACTIVE',
  cancelPending = 'CANCEL_PENDING',
  cancelComplete = 'CANCEL_COMPLETE',
}

export enum EventSessionType {
  GROUP = 'group',
  INDIVIDUAL = 'individual',
}

export interface ISessionLocationParticipant {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}
export interface IModuleSession {
  id: string;
  title: string;
  thumbnailUrl: string;
  sessionType: string;
  audienceType: string;
}
export interface ISummaryModule {
  name: string;
  session: IModuleSession[];
  form: string[];
  content: IContentAvatar[];
  badge: IBadge;
}
export interface ISessionUpdate {
  user: {
    id?: string;
    avatar?: string;
    name: string;
    email?: string;
  };
  notification: string;
  date: string;
  isLocationParticipant?: boolean;
}

export interface ISessionSummary {
  [x: string]: any;
  user: {
    id: string;
    avatar: string;
    name: string;
    email?: string;
  } | null;
  userSessionId: string;
  bookedAt: string;
  completedAt: string;
  isCompleted?: boolean;
  isCancel?: boolean;
  slot?: {
    from: string;
    to: string;
    date: string;
  };
  userType: string;
  meetingId?: string;
  location?: {
    address: string;
    description?: string;
    participants?: ISessionLocationParticipant[];
    participantsCount?: number;
    eventSessionType?: EventSessionType;
  }
}

export interface ISessionSummaryItem {
  title: string;
  date: string;
  timestamp: number;
  userSessionId?: string;
  slot:
  {
    from: string;
    to: string;
    date: string;
  } | undefined;
  user?: {
    id: string;
    avatar: string;
    name: string;
  } | null;
  deleted?: boolean;
  isCompleted?: boolean;
  isCancel?: boolean;
  meetingId?: string;
}
export interface IStatistic {
  allTimeSessionPurchased: number;
  weeklyTimeSessionPurchased: number;
  userEnrolled: number;
  completed: number;
}

export interface ISessionCertificateUserSession {
  _id: string;
  user: IBaseUserAvatar;
  session: {
    _id?: string;
    id: string;
    certificateIssuance?: boolean;
    sessionType: string;
    title: string;
  };
}

export interface ISessionCertificateItem {
  userSession: ISessionCertificateUserSession;
  certificate: IIssuedCertificate | null;
  completion: number;
}

export interface ISession {
  id: string;
  isActive: boolean;
  sessionType: string;
  audienceType: string;
  title: string;
  description: string;
  language: string;
  numberOfSessions: number;
  waitingRoomMedia: IWaitingMedia;
  locations?: IEventLocation[];
  numberOfParticipants: number;
  isObserverAllowed: boolean;
  numberOfObservers: number;
  forms: string[];
  media: string[];
  availableTimes: IAvailableTime[];
  frequency: Frequency;
  fee: string;
  discount: string;
  expert: IExpertAvatar;
  entId: IEntAccountAvatar;
  currency: string;
  subscriberFee: string;
  subscriberCurrency: string;
  subscriberDiscount: string;
  observerFee: string;
  observerDiscount: string;
  observerCurrency: string;
  subscribeObserverFee: string;
  subscribeObserverCurrency: string;
  subscribeObserverDiscount: string;
  summary: ISessionSummary[];
  updates: ISessionUpdate[];
  modules: ISummaryModule[];
  statistics: IStatistic;
  badge: IBadge;
  certificate?: ICertificate | null;
  certificateIssuance?: boolean;
  sessionMeta: ISessionMeta;
  purchaseHistory: ISessionUpdate[];
  bookedSessions: number;
  bookedObservers: number;
  availableSessions: number;
  availableParticipants: number;
  availableObservers: number;
  invitations:IInvitation[]
  deleted:boolean,
  prerequisites?: { id: string; title: string; }[];
}
export interface IGetSupportModalForm {
  comment: string;
}
export interface IGenerateSession {
  name: string;
  role: string;
  sessionId: string;
  sessionType: string;
}

export interface IGetSessionCertificatesPayload {
  page?: number;
  limit?: number;
  user?: string;
  keyword?: string;
  status?: CertificateStatus;
  issued?: boolean;
  completion?: CertificateSessionCompletionFilter;
}

export interface IExportSessionCertificatesPayload
  extends Omit<IGetSessionCertificatesPayload, 'page' | 'limit'> {}

export interface IBulkIssueSessionCertificatePayload {
  userIds: string[];
}
export interface ViewSessionState {
  sessionId: string;
  stateLoading: boolean;
  loading: boolean;
  certificatesStateLoading: boolean;
  certificatesRefetchTrigger: boolean;
  certificatesExportSuccessTrigger: boolean;
  issuingCertificateUserId: string;
  bulkIssuingCertificatesLoading: boolean;
  exportingCertificatesLoading: boolean;
  session: ISession;
  sessionCertificates: IFiltered<ISessionCertificateItem>;
  sessionUrl: string;
  invitePeople: string[];
  filteredSessions: IFiltered<ISession>;
  subStateLoading: boolean;
  modalState: string;
}

export interface IActive {
  isActive: boolean;
}

export interface CancelSession {
  payload: CancelSessionParams;
  type: string;
}

export interface CancelSessionParams {
  id: string;
  meetingId: string;
  userId: string;
}
